import { withStyles } from "@material-ui/core";
import { Card } from "bc-front-sagacomponents";
import styles from "../style";
import Adherent from "./Adherent";

interface Props {
  classes?: any;
  selectedAdhesionId?: string;
}
const InformationsContent = (props: Props) => {
  const { classes, selectedAdhesionId } = props;

  return (
    <div className={classes.blocInformations}>
      <Card>
        <Adherent selectedAdhesionId={selectedAdhesionId}></Adherent>
      </Card>
    </div>
  );
};
export default withStyles(styles)(InformationsContent);
